<template>
  <el-dialog
    :title="model.id ? '编辑 Banner' : '新增 Banner'"
    :visible.sync="visible"
    width="700px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="80px"
      size="small"
    >
      <el-form-item label="轮播图" prop="cover">
        <el-upload
          :action="uploadUrl"
          accept="image/*"
          :headers="uploadHeader"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :on-error="handleUploadError"
        >
          <auth-img
            tag="el-image"
            style="width: 178px; height: 100px"
            :src="model.cover"
            fit="cover"
            v-if="model.cover"
          ></auth-img>
          <span v-else class="font-12">点击上传</span>
        </el-upload>
        <div class="font-12 text-info">建议宽高比例 16：9</div>
      </el-form-item>
      <el-form-item label="关联对象">
        <el-select v-model="model.category" style="width: 100%">
          <el-option
            v-for="(k, v) in BannerCategoryMap"
            :key="v"
            :label="k"
            :value="parseInt(v)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="商品"
        prop="commodity_id"
        key="commodity"
        v-if="model.category == 2"
      >
        <CommoditySelect
          :val="model.commodity_id"
          @change="model.commodity_id = $event"
          :departmentLimit="false"
        ></CommoditySelect>
      </el-form-item>
      <el-form-item
        label="市场活动"
        prop="wiki_id"
        key="wiki"
        v-else-if="model.category == 3"
      >
        <WikiSelect v-model="model.wiki_id" :type="2"></WikiSelect>
      </el-form-item>
      <el-form-item v-else label="详情" prop="content">
        <RichEditor class="editor mobile" v-model="model.content"></RichEditor>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { createBanner, updateBanner } from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/store'
import { BannerCategoryMap } from '@/config/global'
import CommoditySelect from '@/components/select/commodity_select'
import WikiSelect from '@/components/select/WikiSelect'
import RichEditor from '@/components/rich-editor'

export default {
  components: {
    CommoditySelect,
    WikiSelect,
    RichEditor,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      BannerCategoryMap,
      uploadUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      rules: {
        cover: [{ required: true, message: '请上传轮播图' }],
        commodity_id: [{ required: true, message: '请选择关联商品' }],
        wiki_id: [
          { required: true, message: '请选择关联知识库', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.model.id > 0) {
            let res = await updateBanner(this.model)
            if (res.code == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await createBanner(this.model)
            if (res.code == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.model.cover = res.data
        this.$refs.form.validateField('cover')
      }
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
  },
}
</script>

<style scoped>
/deep/.ql-editor {
  min-height: 200px;
}

/deep/.ql-formats {
  line-height: 0;
}
</style>